export interface UserCredentialRequest {
  Id: number;
  Name?: string;
  CompanyId?: number;
}

export class RequestAPI<T> {
  UserCrendential: UserCredentialRequest | null;
  ObjectRequest: T | null;

  constructor() {
    this.UserCrendential = null;
    this.ObjectRequest = null;
  }
}
